export type CampaignType = 'whatsapp' | 'email' | 'sms';

export type CampaignStatus =
  | 'draft'
  | 'scheduled'
  | 'running'
  | 'paused'
  | 'completed'
  | 'failed';

export interface AudienceFilter {
  categories?: string[];   // slugs; vazio = todos
  tags?: string[];         // slugs; vazio = todos
  neighborhood?: string;
  activeOnly?: boolean;
}

export interface Campaign {
  id: string;
  tenant_id: string;
  name: string;
  description: string | null;
  type: CampaignType;
  message_body: string | null;
  /** Valores para {{2}}, {{3}}, … do template HSM. {{1}} = nome do contato (automático). */
  template_vars: string[];
  status: CampaignStatus;
  audience_filter: AudienceFilter;
  stats_targeted: number;
  stats_sent: number;
  stats_delivered: number;
  stats_read: number;
  stats_failed: number;
  scheduled_at: string | null;
  started_at: string | null;
  completed_at: string | null;
  failure_reason: string | null;
  legal_basis: string;
  created_by: string | null;
  created_at: string;
  updated_at: string;
}

export interface CampaignInsert {
  name: string;
  description?: string | null;
  type: CampaignType;
  message_body?: string | null;
  template_vars?: string[];
  audience_filter?: AudienceFilter;
  scheduled_at?: string | null;
  legal_basis?: string;
}

export interface CampaignUpdate extends Partial<CampaignInsert> {
  status?: CampaignStatus;
  stats_targeted?: number;
  stats_sent?: number;
  stats_delivered?: number;
  stats_read?: number;
  stats_failed?: number;
  started_at?: string | null;
  completed_at?: string | null;
}

/* ─── Metadados de exibição ─────────────────────────────────── */
export const CAMPAIGN_TYPE_LABELS: Record<CampaignType, string> = {
  whatsapp: 'WhatsApp',
  email: 'E-mail',
  sms: 'SMS',
};

export const CAMPAIGN_TYPE_ICONS: Record<CampaignType, string> = {
  whatsapp: '💬',
  email: '✉️',
  sms: '📱',
};

export const CAMPAIGN_STATUS_LABELS: Record<CampaignStatus, string> = {
  draft:     'Rascunho',
  scheduled: 'Agendada',
  running:   'Enviando',
  paused:    'Pausada',
  completed: 'Concluída',
  failed:    'Falhou',
};

export const CAMPAIGN_STATUS_COLORS: Record<CampaignStatus, string> = {
  draft:     'bg-slate-500/15 text-slate-300 border-slate-500/25',
  scheduled: 'bg-blue-500/15 text-blue-300 border-blue-500/25',
  running:   'bg-amber-500/15 text-amber-300 border-amber-500/25',
  paused:    'bg-orange-500/15 text-orange-300 border-orange-500/25',
  completed: 'bg-emerald-500/15 text-emerald-300 border-emerald-500/25',
  failed:    'bg-danger/15 text-danger border-danger/25',
};

export const WHATSAPP_CHAR_LIMIT = 4096;
export const EMAIL_CHAR_LIMIT = 10000;
